import { useEffect } from "react";

/**
 * Syncs `nextCursor` / `hasMore` from a cursor-list API response into
 * `useCursorPagination`. Call once per successful page load.
 */
export function useSyncCursorPage(
  setNextCursor: (next: string | undefined) => void,
  meta: { nextCursor?: string; hasMore?: boolean } | undefined,
  ready: boolean,
) {
  useEffect(() => {
    if (!ready || !meta) return;
    setNextCursor(meta.hasMore === false ? undefined : meta.nextCursor);
  }, [ready, meta?.nextCursor, meta?.hasMore, setNextCursor]);
}
